import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import Navigation from './Navigation';
import CakeCollection from './CakeCollection';
import { useCart } from '../context/CartContext';
import Cart from './Cart';

const CakesPage = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [categories, setCategories] = useState([]);
  const { dispatch } = useCart();

  const addToCart = (cake) => {
    dispatch({ type: 'ADD_TO_CART', payload: cake });
  };

  const handleCategoriesChange = useCallback((cats) => {
    setCategories(cats);
  }, []);

  const tabs = ['all', ...categories];

  return (
    <div className="min-h-screen bg-[#F5EFE4] text-[#3D2817]">
      <Navigation onCartOpen={() => setIsCartOpen(true)} />

      <div className="pt-28 md:pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          {/* Page heading */}
          <div className="text-center space-y-4 mb-12">
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Our Collection</h1>
            <div className="flex items-center justify-center gap-3 text-[#6B7C3F]">
              <span className="h-px w-12 bg-[#6B7C3F]/40" />
              <Heart className="w-4 h-4 fill-current" />
              <span className="h-px w-12 bg-[#6B7C3F]/40" />
            </div>
            <p className="text-[#6B5644] max-w-xl mx-auto">
              Handcrafted pound cakes, baked fresh and delivered across Miami.
            </p>
          </div>

          {/* Category tabs */}
          <div className="mb-12">
            <div className="flex flex-wrap justify-center gap-x-2 gap-y-2 border-y border-[#E5DCC9] py-4">
              {tabs.map((category) => {
                const isActive = selectedCategory === category;
                return (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`capitalize font-serif text-sm tracking-[0.15em] uppercase px-4 py-2 transition-colors ${
                      isActive
                        ? 'text-[#6B7C3F] border-b-2 border-[#6B7C3F]'
                        : 'text-[#6B5644] hover:text-[#3D2817] border-b-2 border-transparent'
                    }`}
                  >
                    {category}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Grid */}
          <CakeCollection
            addToCart={addToCart}
            selectedCategory={selectedCategory}
            showAboutCard={false}
            onCategoriesChange={handleCategoriesChange}
          />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#6B7C3F] text-[#FAF6EE]">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm tracking-[0.1em]">
          <p>© 2024 Nena Miami. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span>Miami, FL</span>
            <Link to="/contact" className="hover:opacity-80 transition-opacity uppercase">Contact</Link>
            <a
              href="https://instagram.com/nenamiami"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity uppercase"
            >
              Instagram
            </a>
          </div>
        </div>
      </footer>

      <Cart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </div>
  );
};

export default CakesPage;
